import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { 
  FaBookMedical,
  FaBookOpen,
  FaBookReader,
  FaPlayCircle
} from 'react-icons/fa';
import './take_break.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { BsJournal } from 'react-icons/bs';
import { MdArticle } from 'react-icons/md';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../auth/firebase';
import { useAuthStore } from '../../../auth/state';
import cacheManager from '../../../auth/cache_manager';

function TakeBreak() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (user && user.uid) {
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, [user]);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      if (user && user.uid) {
        await updateDoc(doc(db, 'users', user.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${user.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Check if we're in admin route
  const isAdminRoute = location.pathname.startsWith('/admin');

  // # Handle section click
  const handleSectionClick = (title) => {
    if (title === "Qur'an") {
      // # Navigate to the appropriate route based on user type
      const basePath = isAdminRoute ? '/admin/community' : '/community';
      navigate(`${basePath}/break/quran`);
    }
  };

  // # Define break sections with icons and descriptions
  const breakSections = [
    {
      title: "Qur'an",
      icon: <FaBookOpen className="ext_brk_section-icon" />,
      description: 'Take a spiritual break with Quranic recitations',
      isReady: true
    },
    {
      title: 'Watch Something',
      icon: <FaPlayCircle className="ext_brk_section-icon" />,
      description: 'Besides medicine, Into politics? Maybe history? Maybe something else?',
      isReady: false
    },
    {
      title: 'Read Something',
      icon: <MdArticle className="ext_brk_section-icon" />,
      description: 'Medicine, Healthcare, and other articles',
      isReady: false
    }
  ];

  return (
    <div className={`ext_brk_page-container ${isDarkMode ? 'ext_brk_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_brk_main-content">
        <div className="ext_brk_header">
          <h1>Take a Break</h1>
          <p>Refresh your mind with these relaxing activities</p>
        </div>

        <div className="ext_brk_sections-grid">
          {breakSections.map((section, index) => (
            <div 
              key={index}
              className={`ext_brk_section-card ${section.isReady ? 'clickable' : ''}`}
              onClick={() => section.isReady && handleSectionClick(section.title)}
            >
              <div className="ext_brk_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              {!section.isReady && (
                <div className="ext_brk_coming-soon">Coming Soon</div>
              )}
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default TakeBreak; 